import { FETCH_USER, CHANGE_AUTH_USER_INFO} from "../actions/types";

export default (state = false, action) => {
  switch (action.type) {
    case CHANGE_AUTH_USER_INFO:
      let auth = {...state}
      if(auth)auth.info = action.payload
      return auth
    case FETCH_USER:
      return action.payload || null;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js